<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới menu</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <!--<b-row>
                            <b-col>
                                <b-form-group label="Tên nhóm menu:"
                                              label-for="name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text"
                                                  style="display:none;"
                                                  v-model="$v.menu.groupMenuId.$model"
                                                  :state="$v.menu.groupMenuId.$dirty? !$v.menu.groupMenuId.$error : null">
                                    </b-form-input>
                                    <select2 class="no-padding col-6 " v-model="$v.menu.groupMenuId.$model"
                                             v-if="groupMenus.length > 0"
                                             :options="groupMenus"
                                             allowClear="true"
                                             placeholder="--- Chọn ---"></select2>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn nhóm menu
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row>
                            <b-col>
                                <b-form-group label="Menu cha:"
                                              label-for="parentId"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <treeselect class="col-6 no-padding" v-model="menu.parentId"
                                                placeholder="--- Chọn ---"
                                                :options="menus" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Tên menu:"
                                              label-for="name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text" id="name"
                                                  class="col-6"
                                                  v-model="$v.menu.name.$model"
                                                  :state="$v.menu.name.$dirty? !$v.menu.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback>
                                        Vui lòng nhập tên menu
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Đường dẫn menu:"
                                              label-for="url"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text" id="url"
                                                  class="col-6"
                                                  v-model="$v.menu.url.$model"
                                                  :state="$v.menu.url.$dirty? !$v.menu.url.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback>
                                        Vui lòng đường dẫn
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Icon:"
                                              label-for="icon"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-input type="text" id="icon"
                                                  class="col-6"
                                                  v-model="menu.icon">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Số thứ tự hiển thị:"
                                              label-align="right"
                                              label-for="description"
                                              :label-cols="4"
                                              :horizontal="true">
                                    <b-form-input type="number"
                                                  class="col-6"
                                                  v-model="menu.displayOrder">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Trạng thái:"
                                              label-align="right"
                                              label-for="status"
                                              :label-cols="4"
                                              :horizontal="true">
                                    <b-form-checkbox id="status" v-model="menu.status" class="col-6 col-form-label"></b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group :label-cols="4"
                                              :horizontal="true">
                                    <b-button type="submit" variant="primary" v-if="authorize(['ManageMmenu'])">Ghi lại</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel"> Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { authorizationMixin } from '@/shared/mixins'
    import { required } from 'vuelidate/lib/validators'
    import { mapState } from 'vuex'
    export default {
        name: 'CreateMenu',
        mixins: [validationMixin, authorizationMixin],
        data() {
            return {
                menu: {
                    name: null,
                    icon: null,
                    url: null,
                    //groupMenuId: null,
                    parentId: null,
                    status: false,
                    displayOrder: null
                },
                //groupMenus: []
            }
        },
        validations: {
            menu: {
                name: { required },
                url: { required },
                //groupMenuId: { required },
            }
        },
        computed: {
            ...mapState({
                groupMenus: (state, getters) => state.common.groupMenus,
            }),
            menus() {
                //if (this.menu.groupMenuId) {
                //    return this.$store.getters.menuTree.filter(x => x.groupMenuId == this.menu.groupMenuId);
                //} else {
                //    return this.$store.getters.menuTree;
                //}
                return this.$store.getters.menuTree;
            }
        },
        created() {
        },
        methods: {
            cancel() {
                this.$router.push({ path: '/system/menus' });
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.post('system/menus', this.menu).done((id) => {
                        vm.$toastr.s('Tạo mới menu thành công');
                        vm.$store.dispatch('loadMenus').done(() => {
                            this.cancel();
                        });
                    });
                }
            }
        }
    }
</script>
<style scoped>
</style>
